<script>
  import { onMount, onDestroy } from "svelte"
  import Typetester from "./components.js"
  import TextFit from "../TextFit.svelte"

  export let typefaces
  export let sentences
  export let mode
  export let text

  let root
  let resizeObserver
  let containerWidth = 0
  let containerHeight = 0
  let focusOnFirst = editable
  let loadedAt = Date.now()

  $: editable = mode === "type"
  $: focusOnFirst = editable
  $: sentence = sentences[0]
  $: textFitState =
    text +
    sentence +
    mode +
    typefaces.map((t) => t.name) +
    containerHeight +
    containerWidth +
    loadedAt

  export function selectNewSentence() {
    sentences = sentences.filter((s) => s !== sentence)
  }

  function compareTypefaces(a, b) {
    if (a.width.order > b.width.order) return 1
    if (a.width.order < b.width.order) return -1
    if (a.weight.order > b.weight.order) return 1
    if (a.weight.order < b.weight.order) return -1
  }

  function onClick() {
    if (mode === "sample") selectNewSentence()
  }

  function onLoaded() {
    loadedAt = Date.now()
  }

  onMount(() => {
    resizeObserver = new ResizeObserver((entries) => {
      const entry = entries.at(0)
      const size = entry.contentBoxSize[0]
      containerWidth = size.inlineSize
      containerHeight = size.blockSize
    })
    resizeObserver.observe(root)
  })

  onDestroy(() => {
    resizeObserver.unobserve(root)
  })
</script>

<div class="root" data-mode={mode} bind:this={root}>
  {#if mode === "sample"}
    <button on:click={onClick} />
  {/if}
  <div class="textfit">
    <TextFit
      minFontSize={10}
      {containerWidth}
      {containerHeight}
      update={textFitState}
    >
      {#each typefaces.sort(compareTypefaces) as typeface, index (typeface.name)}
        <div class="typeface">
          <Typetester.Typeface
            {sentence}
            {editable}
            focused={index === 0 && focusOnFirst}
            {typeface}
            bind:text
            on:loaded={onLoaded}
          />
        </div>
      {/each}
    </TextFit>
  </div>
</div>

<style>
  .root {
    width: 100%;
    flex: 0 0 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    text-align: center;
    position: absolute;
    inset: 0;
    overflow: visible;
  }

  button {
    position: absolute;
    inset: 0;
    cursor: pointer;
  }

  .textfit {
    display: flex;
    flex: 1 0 100%;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    text-align: center;
    line-height: 1em;
  }

  .textfit :global(> *) {
    line-height: 1em;
  }

  .typeface {
    display: inline;
  }

  .typeface :global(*) {
    display: inline;
  }

  div[data-mode="sample"] {
    user-select: none;
    -webkit-user-select: none;
  }
</style>
